import { immerable } from 'immer';

/* -------------------------------------------------------------------------------------------------
 * IFeatureRolloutModel
 * -----------------------------------------------------------------------------------------------*/
export interface IFeatureRolloutModel {
    _id: string;
    name: string;
    state?: any;
}

/* -------------------------------------------------------------------------------------------------
 * AvailablePluginModel
 * -----------------------------------------------------------------------------------------------*/
export class FeatureRolloutModel {
    [immerable] = true;

    _id: string;
    name: string;
    state?: any;

    constructor(data: Partial<IFeatureRolloutModel>) {
        this._id = data._id;
        this.name = data.name;
        this.state = data.state;
    }

    static fromObject(data: Partial<IFeatureRolloutModel>): FeatureRolloutModel {
        const model = new FeatureRolloutModel(data);

        return model;
    }

    static cloneFrom(data: Partial<IFeatureRolloutModel>): FeatureRolloutModel {
        const model = new FeatureRolloutModel(data);

        return model;
    }

    static fromObjectList(data: Partial<IFeatureRolloutModel>[]): FeatureRolloutModel[] {
        return data.map((row) => FeatureRolloutModel.fromObject(row));
    }

    toObject(): IFeatureRolloutModel {
        const data: IFeatureRolloutModel = {
            _id: this._id,
            name: this.name,
            state: this.state,
        };

        return data;
    }
}
